<section class="breadcrumb-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-title">
          <h1> Co-Curricular Events</h1>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-lg std-scholarship">
  <div class="container">
    <div class="row row-50">
      <div class="col-md-12">
        <div class="vertical-tabs">
          <ul class="nav nav-pills flex-row" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab" aria-controls="tab1"
                aria-selected="true">Education cell (Edification)</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab" aria-controls="tab2"
                aria-selected="false">Industry Institute Interaction cell</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3"
                aria-selected="false">Short term course</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4"
                aria-selected="false">Toastmaster</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="tab5-tab" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab5"
                aria-selected="false">Encarta – IT cell</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="tab6-tab" data-toggle="tab" href="#tab6" role="tab" aria-controls="tab6"
                aria-selected="false">Engfinity</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="tab7-tab" data-toggle="tab" href="#tab7" role="tab" aria-controls="tab7"
                aria-selected="false"> CNA Forum</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-12">
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
            <div class="inner-title">
              <h3>Education cell (Edification)</h3>

            </div>
            <div class="row mb-20">
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/Engfinity-1.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/Engfinity-1.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Activitiy Representers</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/Engfinity-2.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/Engfinity-2.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Month end Presentation</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/Engfinity-3.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/Engfinity-3.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Student Teacher Interaction</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/Engfinity-4.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/Engfinity-4.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Weekly presentation</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/mng_fest-1.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/mng_fest-1.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Management Fest </h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/mng_fest-2.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/mng_fest-2.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Management Fest </h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/mng_fest-3.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/mng_fest-3.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Management Fest </h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/mng_fest-4.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/mng_fest-4.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Management Fest </h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/tecnovision.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/tecnovision.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Techno vision </h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/MUN.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/MUN.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Model United Nations</h6>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">
            <div class="inner-title">
              <h3>Industry Institute Interaction cell
              </h3>

            </div>
            <div class="row mb-20">
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/iii_morarjee.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/iii_morarjee.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Industrial Visit Morarjee Texttile</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/iii_CETP.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/iii_CETP.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Industrial Visit CETP Water Treatment Plant</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/iii_guest.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/iii_guest.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Guest Lecture</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/iii_jain_farm.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/iii_jain_farm.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Industrial Visit Jain Farm Fresh, Jalgaon</h6>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">
            <div class="inner-title">
              <h3>Short term course
              </h3>

            </div>
            <div class="row mb-20">
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/stc_exel.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/stc_exel.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Basic & Advance Excel</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/stc_simu.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/stc_simu.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Basic & Advanced Simulation</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/stc-dig.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/stc-dig.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Digital Marketing</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/stc-fina.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/stc-fina.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Reading of financial statements</h6>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">
            <div class="inner-title">
              <h3>Toastmaster
              </h3>

            </div>
            <div class="row mb-20">
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/toast-1.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/toast-1.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Toastmaster</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/toast-2.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/toast-2.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Toastmaster</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/toast-3.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/toast-3.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Toastmaster</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/toast-4.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/toast-4.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Toastmaster</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/toast-5.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/toast-5.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Toastmaster</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/toast-6.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/toast-6.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Toastmaster</h6>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">
            <div class="inner-title">
              <h3>Encarta – IT cell
              </h3>

            </div>
            <div class="row mb-20">
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/techno-1.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/techno-1.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Glimpse of the Techno Quiz Competition</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/techno-5.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/techno-5.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Glimpse of the Techno Quiz Competition</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/software-1.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/software-1.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Glimpse of the Two Day’s Workshop on Software Testing</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/software-2.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/software-2.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Glimpse of the Two Day’s Workshop on Software Testing</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/software-3.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/software-3.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Glimpse of the Two Day’s Workshop on Software Testing</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/enc_champion-1.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/enc_champion-1.webp" alt="Events  | Ghrcacsn"
                      title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Kaun Banega Champion</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/enc_champion-2.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/enc_champion-2.webp" alt="Events  | Ghrcacsn"
                      title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Kaun Banega Champion</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/enc_champion-3.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/toast-3.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Kaun Banega Champion</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/poker_face-6.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/poker_face-6.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Poker Face</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/poker_face-4.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/poker_face-4.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Poker Face</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/poker_face-1.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/poker_face-1.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Poker Face</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/poker_face-2.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/poker_face-2.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Poker Face</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/poker_face-3.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/poker_face-3.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Poker Face</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/enc_gl-3.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/enc_gl-3.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Guest Lecture</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/enc_gl-1.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/enc_gl-1.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Guest Lecture</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/enc_gl-2.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/enc_gl-2.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Guest Lecture</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/deal_nodeal.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/deal_nodeal.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Deal or No Deal</h6>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="tab6" role="tabpanel" aria-labelledby="tab6-tab">
            <div class="inner-title">
              <h3>Engfinity
              </h3>

            </div>
            <div class="row mb-20">
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/Engfinity-1.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/Engfinity-1.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Activitiy <br>Representers</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/Engfinity-2.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/Engfinity-2.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Month end Presentation</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/Engfinity-3.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/Engfinity-3.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Student Teacher Interaction</h6>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/Engfinity-4.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/Engfinity-4.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                    <div class="gallery-overlay">
                      <h6>Weekly<br> presentation</h6>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="tab7" role="tabpanel" aria-labelledby="tab7-tab">
            <div class="inner-title">
              <h3>Current News Analysis
              </h3>

            </div>
            <div class="row row-50">
              <div class="col-md-3">
                <div class="vertical-tabs">
                  <ul class="nav nav-pills flex-column" id="myTab" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link active" id="tab01-tab" data-toggle="tab" href="#tab01" role="tab"
                        aria-controls="tab01" aria-selected="true">Program Objective
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" id="tab02-tab" data-toggle="tab" href="#tab02" role="tab"
                        aria-controls="tab02" aria-selected="false">Program Outcome</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" id="tab03-tab" data-toggle="tab" href="#tab03" role="tab"
                        aria-controls="tab03" aria-selected="false">Results</a>
                    </li>

                  </ul>
                </div>
              </div>
              <div class="col-md-9">
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="tab01" role="tabpanel" aria-labelledby="tab01-tab">
                    <div class="section-title">
                      <h4>Program Objective
                      </h4>

                    </div>
                    <div class="text-justify">
                      <ul class="list-item">
                        <li> To provide an idea as to how to analyze a news.</li>
                        <li>To raise the inclination of participation and confidence of students in the Forum and
                          different activities.</li>
                        <li>To make them able to differentiate between real and fake news.</li>
                        <li>To make them aware with current affairs and news.</li>
                        <li>To polish students’ communication skills and to develop their general awareness.</li>
                      </ul>
                      <p>The CNA Forum of G.H.Raisoni College of Commerce, Science and Technology Organized “The News
                        Analysis Competition” on 20 th May, 2022 at 11:00 am. It was organized the Students’Activity
                        room.</p>
                      <p>The main objective of this competition was to explain how to correctly analyze news. Respected
                        faculties along with the members of the forums attended the competition at the scheduled time of
                        the competition.</p>
                      <p>The competition was conducted by CNA Forum students in the presence of Prof. Kalyani Dubey -
                        Coordinator CNA Forum. The esteemed guest for the workshop was the Alumni - Ms. Shabla Sharma
                        who is a HR Executive at Aviation Indeed.</p>
                      <p>The compering was done by the CNA member Riya Shrivastava, Students of BCCA,GHRCCST and did a
                        commendable job. The ceremony started by introducing the guest and later the purpose of the
                        event was narrated.</p>
                      <p>The guest of the day Ms. Shabla Sharma then took over and stole the spotlight by her experience
                        and knowledge. There were 4 teams of students which participated in the workshop. Each team
                        chose recent news and presented their views on it one by one. A healthy discussion took place
                        between the participants and the guest, on which, later, Ms. Shabla Sharma guided them
                        properly. Her guidance was really informative for the students to start an approach towards
                        getting familiar to the current affairs and to analyze it properly.</p>
                      <p>The ceremony concluded by the vote of thanks by Drishti Kataria BBA, G H RCCST.</p>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="tab02" role="tabpanel" aria-labelledby="tab02-tab">
                    <div class="section-title">
                      <h4>Program Outcome </h4>


                    </div>
                    <div class="text-justify">
                      <p>The News Analysis Competition was a great success and really informative. The students could
                        realize the importance of news analysis and presentation of the same.</p>
                    </div>

                  </div>
                  <div class="tab-pane fade" id="tab03" role="tabpanel" aria-labelledby="tab03-tab">
                    <div class="section-title">
                      <h4>Results</h4>


                    </div>

                    <div class="row justify-content-center mt-3">
                      <div class="col-6">
                        <ul class="list-item">
                          <li><strong>Winner </strong> - TEAM E</li>
                          <li><strong>Topic </strong> - Freebies- Economical Threat</li>
                          <li><strong>Name of the participants:</strong>
                            <ul>
                              <li>Sumit Kelapure</li>
                              <li>Husain Zariwala</li>
                              <li>Sanvi Tumane</li>
                            </ul>
                          </li>

                        </ul>
                      </div>
                      <div class="col-6">
                        <ul class="list-item">
                          <li><strong>Runner Up</strong> - TEAM C</li>
                          <li><strong>Topic </strong> - Hijab Controversy</li>
                          <li><strong>Name of the participants:</strong>
                            <ul>
                              <li>Shruti Gupta</li>
                              <li>Syed Kaif Ali</li>
                              <li>Arjit Gupta</li>
                              <li>Sahil Yadav</li>
                            </ul>
                          </li>

                        </ul>
                      </div>
                    </div>

                    <div class="row justify-content-center mt-3">
                      <div class="col-lg-3 col-6 col-md-4">
                        <div class="gallery-item" data-aos="zoom-in-down">
                          <a href="assets/images/gallery/cna-1.webp" data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid" src="assets/images/gallery/cna-1.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                            <div class="gallery-overlay">
                              <!-- <h6>International Tour</h6> -->
                            </div>
                          </a>
                        </div>
                      </div>
                      <div class="col-lg-3 col-6 col-md-4">
                        <div class="gallery-item" data-aos="zoom-in-down">
                          <a href="assets/images/gallery/cna-2.webp" data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid" src="assets/images/gallery/cna-2.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                            <div class="gallery-overlay">
                              <!-- <h6>National Tour</h6> -->
                            </div>
                          </a>
                        </div>
                      </div>
                      <div class="col-lg-3 col-6 col-md-4">
                        <div class="gallery-item" data-aos="zoom-in-down">
                          <a href="assets/images/gallery/cna-3.webp" data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid" src="assets/images/gallery/cna-3.webp" alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                            <div class="gallery-overlay">
                              <!-- <h6>National Tour</h6> -->
                            </div>
                          </a>
                        </div>
                      </div>

                    </div>

                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>